import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UnsavedModal from '../../../components/unsaved-modal/UnsavedModal';
import useRedirectPrompt from '../../../hooks/useRedirectPrompt';
import { setEditableMessage, setIsDirty } from '../../../redux/id8/id8Reducer';

function UnsavedModalController({
  isShowUnsavedModal,
  onChangeUnsavedModalVisibility,
  resetAction,
  triggerAction,
  onSaveChanges,
}) {
  const dispatch = useDispatch();
  const isDirty = useSelector((state) => state.id8.isDirty);
  const editableMessage = useSelector((state) => state.id8.editableMessage);

  const [showPrompt, confirmNavigation, cancelNavigation] = useRedirectPrompt(!!editableMessage.id && isDirty);

  const handleCancelModal = () => {
    onChangeUnsavedModalVisibility(false);
    resetAction(null);

    if (showPrompt) {
      cancelNavigation();
    }
  };

  const handleDontSave = () => {
    onChangeUnsavedModalVisibility(false);
    dispatch(setEditableMessage({ id: null, message: null }));
    dispatch(setIsDirty(false));

    if (triggerAction) {
      triggerAction();
    }

    if (showPrompt) {
      confirmNavigation();
    }
  };

  const handleSaveModal = async () => {
    onChangeUnsavedModalVisibility(false);

    if (onSaveChanges) {
      await onSaveChanges();
    }

    if (triggerAction) {
      triggerAction();
    }

    if (showPrompt) {
      confirmNavigation();
    }
  };

  useEffect(() => {
    onChangeUnsavedModalVisibility(showPrompt);
  }, [showPrompt, onChangeUnsavedModalVisibility]);

  return (
    <UnsavedModal
      isOpen={isShowUnsavedModal}
      onCancel={handleCancelModal}
      onClose={handleCancelModal}
      onDontSave={handleDontSave}
      onSave={handleSaveModal}
    />
  );
}

export default UnsavedModalController;
